import { useState } from "react";
import { FmcsaInspectionListDto } from "../../../common/data/service-proxies";
import { ListMenuItemProps } from "../../common/list/ListMenuItemProps";
import { useNotify } from "react-admin";
import { isBoolean } from "lodash";
import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { MarkFmcsaInspectionUnofficialDialog } from "./MarkFmcsaInspectionUnofficialDialog";

interface Props extends ListMenuItemProps<FmcsaInspectionListDto> {}

export const MarkFmcsaInspectionUnofficialMenuItem = ({
  record,
  hidden,
  label,
  icon,
  onClick,
  onSuccess,
  ...rest
}: Props) => {
  const [isConfirmOpen, setConfirmOpen] = useState(false);
  const notify = useNotify();

  if (!record?.id) {
    return null;
  }

  if (isBoolean(hidden)) {
    if (hidden) {
      return null;
    }
  } else {
    if (hidden && hidden(record)) {
      return null;
    }
  }

  const handleDialogClose = () => {
    setConfirmOpen(false);
  };

  return (
    <>
      <MenuItem
        {...rest}
        className="actions-menu-item"
        onClick={(e) => {
          setConfirmOpen(true);
          if (typeof onClick === "function") {
            onClick(e);
          }
        }}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText>{label}</ListItemText>
      </MenuItem>
      <MarkFmcsaInspectionUnofficialDialog
        isOpen={isConfirmOpen}
        onClose={handleDialogClose}
        onSuccess={() => {
          if (onSuccess) {
            onSuccess();
          }

          notify(
            "resources.fmcsa-data-transfer.notifications.markedUnofficial",
            {
              type: "success",
            }
          );

          handleDialogClose();
        }}
        record={record}
      />
    </>
  );
};
